<template>
  <v-layout>
    <div class="padding-container-lg">
      <v-patient-form :patient="patient" :actionType="`add`" @submit="validateBeforeSubmit"></v-patient-form>
    </div>
  </v-layout>
</template>

<script>
import VPatientForm from '@/components/patient/PatientForm/index.vue';
import VLayout from '@/layouts/Default.vue';
import { mapGetters } from "vuex";


export default {
  name: 'CreatePatient',
  components: { VPatientForm, VLayout },
  data() {
    return {
      patient: {
        first_name: '',
        last_name: '',
        email: '',
        mobile_no: '',
        gender: null,
        dob: '',
        country_code: ''
      },
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/getUser"
    }),
  },
  methods: {
    validateBeforeSubmit(data) {
      const isCareNavigator = this.currentUser.designation === 'CARE_NAVIGATOR' ? true : false;
      const formData = {data, isCareNavigator};
       this.$store.dispatch('patient/create', formData);
    },
    onMobileInputChange({ isValid, country }, mobileNumber) {
      this.isMobileNumberValid = isValid;
      this.patient.mobile_no = mobileNumber;
      this.patient.country_code = country.dialCode;
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "./style.scss";
</style>
